// extracted by mini-css-extract-plugin
export default {"container":"BrandManagement_container__SaRui"};